export default __webpack_public_path__ + "static/media/cone_blue.746ca5e8.png";